/** Company primary actions use the applied interface tokens, or the standard gold/ink defaults. */
export const defaultCompanyPrimaryAction = { fill: '#e8bf21', text: '#1a1918' };

export const resolveCompanyPrimaryAction = (configuration: unknown) => {
  const source = configuration && typeof configuration === 'object'
    ? (configuration as { interfaceTokens?: unknown }).interfaceTokens
    : null;
  const tokens = source && typeof source === 'object'
    ? source as Record<string, unknown> : {};
  const color = (value: unknown, fallback: string) =>
    typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value) ? value : fallback;
  return {
    fill: color(tokens.brandPrimary, defaultCompanyPrimaryAction.fill),
    text: color(tokens.brandPrimaryText, defaultCompanyPrimaryAction.text)
  };
};

/** The selected Contracts header palette, shared by Admin actions. */
export const selectedHeaderPalette = {
  border: '#7c6330',
  text: '#f7df9c',
  backgroundImage:
    'linear-gradient(180deg,rgba(245,206,123,0.22),rgba(255,255,255,0.06))',
  shadow: '0 10px 26px rgba(232,191,33,0.12)'
};

export const adminActionButtonSx = {
  // Give the translucent header highlight its dark backing on light pages.
  backgroundColor: 'var(--button-action-fill, #202020)',
  backgroundImage: `var(--button-action-gradient, ${selectedHeaderPalette.backgroundImage})`,
  color: 'var(--button-action-text, #f7df9c)',
  borderColor: 'var(--button-action-border, #7c6330)',
  borderStyle: 'solid',
  borderWidth: 1,
  boxShadow: `var(--button-action-shadow, ${selectedHeaderPalette.shadow})`,
  textTransform: 'none' as const,
  '&:hover': {
    backgroundColor: 'var(--button-action-hover-fill, #303030)',
    backgroundImage: `var(--button-action-gradient, ${selectedHeaderPalette.backgroundImage})`,
    color: 'var(--button-action-text, #f7df9c)',
    borderColor: 'var(--button-action-border, #7c6330)',
    boxShadow: `var(--button-action-shadow, ${selectedHeaderPalette.shadow})`
  },
  '&:focus-visible, &.Mui-focusVisible': {
    outline: '2px solid var(--button-action-border, #7c6330)',
    outlineOffset: 3
  },
  '&:active': {
    backgroundColor: 'var(--button-action-fill, #202020)',
    boxShadow: 'none'
  },
  '&.Mui-disabled': {
    backgroundColor: 'var(--button-disabled-fill, #eeeeee)',
    backgroundImage: 'none',
    color: 'var(--button-disabled-text, #626262)',
    borderColor: 'var(--button-disabled-border, #bdbdbd)',
    boxShadow: 'none'
  }
};

/** Companion/back actions use the existing secondary company colors. */
export const adminSecondaryActionButtonSx = {
  ...adminActionButtonSx,
  backgroundColor: 'var(--button-secondary-fill, #ffffff)',
  backgroundImage: 'none',
  color: 'var(--button-secondary-text, #1a1918)',
  borderColor: 'var(--button-secondary-border, #1a1918)',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'var(--button-secondary-hover-fill, #ebebeb)',
    backgroundImage: 'none',
    color: 'var(--button-secondary-text, #1a1918)',
    borderColor: 'var(--button-secondary-border, #1a1918)',
    boxShadow: 'none'
  },
  '&:focus-visible, &.Mui-focusVisible': {
    outline: '2px solid var(--button-secondary-border, #1a1918)',
    outlineOffset: 3
  },
  '&:active': {
    backgroundColor: 'var(--button-secondary-fill, #ffffff)',
    boxShadow: 'none'
  }
};
